import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SingleState from '../states/single.state';

interface StatusData {
    [key: string]: any;
}

const initialState: SingleState = {
    data: {},
    loading: false,
    error: null,
};

const statusSlice = createSlice({
    name: 'status',
    initialState,
    reducers: {
        setStatusData: (state, action: PayloadAction<StatusData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
    },
});

export const { setStatusData } = statusSlice.actions;
export default statusSlice.reducer;
